import Vue from "vue";
import i18n from "@/plugins/i18n/translations";

export default {
	state: {
		filterConfig: {},
		vendors: [],
		vendorsPagination: {},
		materialFilterConfig: {},
		materials: [],
		materialsPagination: {}
	},
	mutations: {
		setFilterConfigOnState(state, filterConfig) {
			state.filterConfig = filterConfig;
		},
		setVendorsOnState(state, vendors) {
			let mappedVendors = mapStatusToFront(vendors);
			let sortedVendors = mappedVendors.sort((a, b) => a.supplierName - b.supllierName);
			state.vendors = sortedVendors;
		},
		setFamiliesStatusOnVendors(state, supplierWithFamilies) {
			let supplier = state.vendors.find((a) => a.idSupplier == supplierWithFamilies.idSupplier);
			Vue.set(supplier, "families", supplierWithFamilies.familiesStatus);
		},
		setVendorsPaginationOnState(state, vendorsPagination) {
			state.vendorsPagination = vendorsPagination;
		},
		setMaterialFilterConfigOnState(state, materialFilterConfig) {
			state.materialFilterConfig = materialFilterConfig;
		},
		setMaterialsOnState(state, materials) {
			let mappedMaterials = mapStatusToFront(materials);
			let sortedMaterials = mappedMaterials.sort((a, b) => a.descriptionShort - b.descriptionShort);
			state.materials = sortedMaterials;
		},
		setMaterialsPaginationOnState(state, materialsPagination) {
			state.materialsPagination = materialsPagination;
		}
	},
	actions: {
		getVendorsFilterConfig({ state, commit }) {
			const { idUser } = state.actualUser;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("VendorList/" + idUser)
					.then((response) => {
						commit("setFilterConfigOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		getMaterialsFilterConfig({ state, commit }) {
			const { idUser } = state.actualUser;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("VendorList/material/filter/" + idUser)
					.then((response) => {
						commit("setMaterialFilterConfigOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		editVendorsFilterConfig({ state }, filterConfig) {
			const { idUser } = state.actualUser;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("VendorList/" + idUser, filterConfig)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		editMaterialsFilterConfig({ state }, materialFilterConfig) {
			const { idUser } = state.actualUser;
			materialFilterConfig.idUser = idUser;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.put("VendorList/material/filter", materialFilterConfig)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		getVendors({ commit }, filter) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.post("vendorList", filter)
					.then((response) => {
						this.state.loading = false;
						commit("setVendorsOnState", response.data.data.list);
						commit("setVendorsPaginationOnState", response.data.data.pagination);
						resolve(response);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getMaterials({ commit }, filter) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.post("VendorList/material/all", filter)
					.then((response) => {
						this.state.loading = false;
						commit("setMaterialsOnState", response.data.data.materialList);
						commit("setMaterialsPaginationOnState", response.data.data.pagination);
						resolve(response);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getFamiliesStatus({ commit }, supplier) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.post("vendorList/supplier", supplier)
					.then((response) => {
						let supplierWithFamilies = {
							idSupplier: supplier.idSupplier,
							familiesStatus: response.data.data[0].families
						};
						this.state.loading = false;
						commit("setFamiliesStatusOnVendors", supplierWithFamilies);
						resolve(response.data.data[0].families);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		}
	},

	getters: {
		filterConfig: ({ filterConfig }) => {
			return filterConfig;
		},
		vendors({ vendors }) {
			return vendors;
		},
		familiesStatus({ familiesStatus }) {
			return familiesStatus;
		},
		vendorsPagination({ vendorsPagination }) {
			return vendorsPagination;
		},
		materialFilterConfig: ({ materialFilterConfig }) => {
			return materialFilterConfig;
		},
		materials({ materials }) {
			return materials;
		},
		materialsPagination({ materialsPagination }) {
			return materialsPagination;
		}
	}
};

const mapStatusToFront = (values) => {
	let response = [];
	values.forEach((value) => {
		let statusDescription = i18n.t("commons.homologationSituation.pending");
		let statusVariant = "secondary";

		switch (value.idStatus) {
			case 1:
				statusDescription = i18n.t("commons.homologationSituation.closeToExpire");
				statusVariant = "warning";
				break;
			case 2:
				statusDescription = i18n.t("commons.homologationSituation.expiredRequirements");
				statusVariant = "danger";
				break;
			case 3:
				statusDescription = i18n.t("commons.homologationSituation.homologated");
				statusVariant = "success";
				break;
			case 4:
				statusDescription = i18n.t("commons.active");
				statusVariant = "success";
				break;
			case 5:
				statusDescription = i18n.t("commons.inactive");
				statusVariant = "secondary";
				break;
			case 6:
				statusDescription = i18n.t("commons.homologationSituation.inHomologation");
				statusVariant = "info";
				break;
			case 7:
				statusDescription = i18n.t("commons.homologationSituation.canceled");
				statusVariant = "danger";
				break;
			case 8:
				statusDescription = i18n.t("commons.homologationSituation.homologated_inHomologation");
				statusVariant = "success";
				break;
			case 9:
				statusDescription = i18n.t("commons.homologationSituation.expiredRequirements_inHomologation");
				statusVariant = "danger";
				break;
		}
		response.push({
			...value,
			statusDescription,
			statusVariant,
			activeStatus: value.isActive ? i18n.t("commons.active") : i18n.t("commons.inactive")
		});
	});

	return response;
};
